export enum ENiBoostTypes {
  PRODUCTS = 'PRODUCTS',
  FILMCAM = 'FILMCAM',
  ACCESSORIES = 'ACCESSORIES',
  PARTS = 'PARTS',
  REFURBISHED = 'REFURBISHED',
  ARCHIVED = 'ARCHIVED',
  OTHER = 'OTHER',
}
